import TagManager from "react-gtm-module";

function MapButtonScrolldown({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "map_button_scrolldown",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default MapButtonScrolldown;
